import Editorial from './editorial';

export default Editorial;
